import { DateTime } from 'luxon';
import { ParkingTariffValidity } from './parking-tariff-validity';
import './parking-validity-extension';

export interface ITariffSelectionStrategy
{
  selectNext(selectionAt: DateTime, currentTariffValidity: ParkingTariffValidity): ParkingTariffValidity;
}

export abstract class TariffSelectionStrategy implements ITariffSelectionStrategy
{
  public tariffValidityList: ParkingTariffValidity[];

  protected constructor(tariffValidityList: ParkingTariffValidity[])
  {
    this.tariffValidityList = tariffValidityList;
  }

  public static Factory(tariffValidityList: ParkingTariffValidity[]): ITariffSelectionStrategy
  {
    return new TariffSelectionStrategyTariffWithMaxCoverage(tariffValidityList);//TariffSelectionStrategyFirstFromList(tariffs);
  }

  public abstract selectNext(selectionAt: DateTime, currentTariffValidity: ParkingTariffValidity): ParkingTariffValidity;
}

/* export class TariffSelectionStrategyFirstFromList extends TariffSelectionStrategy
{
  constructor(tariffValidityList: ParkingTariffValidity[])
  {
    super(tariffValidityList);
  }

  public selectNext(selectionAt: DateTime, currentTariffValidity: ParkingTariffValidity): ParkingTariffValidity
  {
    // first check if there are any non foreign parking subscriptions available
    const nonFallbackParkingTariffValidityList = this.tariffValidityList?.getNonFallbackParkingTariffs();
    if (nonFallbackParkingTariffValidityList?.length > 0)
    {
      return nonFallbackParkingTariffValidityList[0]; // We take the first. Here we need to use strategy for selection
    }
    else
    {
      return this.tariffValidityList?.getFallbackParkingTariffs();
    }
  }
} */

export class TariffSelectionStrategyTariffWithMaxCoverage extends TariffSelectionStrategy
{
  constructor(tariffValidityList: ParkingTariffValidity[])
  {
    super(tariffValidityList);
  }

  public selectNext(selectionAt: DateTime, currentTariffValidity: ParkingTariffValidity): ParkingTariffValidity
  {
    const nonFallbackParkingTariffValidityList = this.tariffValidityList?.getNonFallbackParkingTariffs();
    if (nonFallbackParkingTariffValidityList?.length > 0)
    {
      if (nonFallbackParkingTariffValidityList.length > 1)
      {
        nonFallbackParkingTariffValidityList.sort((a, b) => this.calculateMintuesLeft(selectionAt, a) - this.calculateMintuesLeft(selectionAt, b));
      }
      const selectedValidity = nonFallbackParkingTariffValidityList[0];

      if (selectedValidity.endDateTime.toMillis() !== selectionAt.toMillis()) {
        return selectedValidity;
      }
    }

    const fallbackValidityList = this.tariffValidityList?.getFallbackParkingTariffs();
    if (fallbackValidityList) {
      if (fallbackValidityList?.length > 1) {
        fallbackValidityList.sort((a, b) => this.calculateMintuesLeft(selectionAt, a) - this.calculateMintuesLeft(selectionAt, b));
      }
      const fallbackValidity = fallbackValidityList[0];
      if (fallbackValidity?.endDateTime !== selectionAt)
    {
        return fallbackValidity;
    }
    }

    return null;
  }

  private calculateMintuesLeft(selectionAt: DateTime, tariffValidity: ParkingTariffValidity): number {
    const minutesLeft = tariffValidity.endDateTime.diff(selectionAt).toMillis() / 60000;
    return Math.min(minutesLeft, tariffValidity.tariff.maxParkingDurationInMin ?? Number.MAX_SAFE_INTEGER);
  }
}
